import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gql, useQuery } from '@apollo/client';

var _templateObject;
var PrivateProfileQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query PrivateProfile($userId: ID!) {\n        networkUser(userId: $userId) {\n            isProfilePrivate\n        }\n    }\n"])));
var usePrivateProfileQuery = function usePrivateProfileQuery(_ref) {
  var userId = _ref.userId;
  var _useQuery = useQuery(PrivateProfileQuery, {
      variables: {
        userId: userId
      }
    }),
    data = _useQuery.data;
  return {
    data: data === null || data === void 0 ? void 0 : data.networkUser
  };
};

export { PrivateProfileQuery, usePrivateProfileQuery };
